import { useState } from "react";

interface UseStepManagerOptions {
  initialStep?: number;
  maxSteps?: number;
}

export function useStepManager({
  initialStep = 1,
  maxSteps,
}: UseStepManagerOptions = {}) {
  const [stepNumber, setStepNumber] = useState(initialStep);

  const nextStep = () => {
    if (!maxSteps || stepNumber < maxSteps) {
      setStepNumber(stepNumber + 1);
    }
  };

  const previousStep = () => {
    if (stepNumber > 1) {
      setStepNumber(stepNumber - 1);
    }
  };

  const goToStep = (step: number) => {
    if (step >= 1 && (!maxSteps || step <= maxSteps)) {
      setStepNumber(step);
    }
  };

  const resetSteps = () => {
    setStepNumber(initialStep);
  };

  return {
    stepNumber,
    nextStep,
    previousStep,
    goToStep,
    resetSteps,
    isFirstStep: stepNumber === 1,
    isLastStep: maxSteps ? stepNumber === maxSteps : false,
  };
}
